import React from 'react';
import { companyInfo } from '../data/mock';
import { Award, Package, Shield, Truck } from 'lucide-react';

const About = () => {
  return (
    <div style={{ backgroundColor: '#fffef2' }}>
      {/* Hero Section */}
      <section className="section-padding">
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h1 className="hero-large" style={{ marginBottom: '24px' }}>
                About EASY2HOME
              </h1>
              <p className="body-large" style={{ 
                color: '#666666', 
                marginBottom: '24px',
                lineHeight: '1.7'
              }}>
                {companyInfo.about}
              </p>
              <p className="body-large" style={{ 
                color: '#666666',
                lineHeight: '1.7'
              }}>
                We believe in creating products that not only serve a purpose but also enhance the aesthetic appeal of your spaces. Each product is carefully designed with attention to detail, ensuring both functionality and style.
              </p>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_amazon-products-3/artifacts/i004pfs7_logowithr%20600%20x%20180.jpeg"
                alt="EASY2HOME"
                style={{
                  maxWidth: '100%',
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section-padding-small" style={{
        backgroundColor: '#f6f5e8'
      }}>
        <div className="container">
          <h2 className="hero-medium" style={{ 
            textAlign: 'center', 
            marginBottom: '64px' 
          }}>
            Why Choose EASY2HOME
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '48px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#fffef2',
                borderRadius: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px'
              }}>
                <Award size={40} color="#333333" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Premium Quality
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                We use only the finest materials to ensure our products stand the test of time.
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#fffef2',
                borderRadius: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px'
              }}>
                <Package size={40} color="#333333" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Easy Installation
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                All products come with clear instructions and necessary hardware for hassle-free setup.
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#fffef2',
                borderRadius: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px'
              }}>
                <Truck size={40} color="#333333" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Fast Delivery
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                Quick and reliable shipping across India with secure packaging.
              </p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#fffef2',
                borderRadius: '0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px'
              }}>
                <Shield size={40} color="#333333" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                Secure Shopping
              </h3>
              <p className="body-regular" style={{ color: '#666666' }}>
                Safe and secure payment processing with buyer protection.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="hero-medium" style={{ marginBottom: '24px' }}>
              Our Mission
            </h2>
            <p className="body-large" style={{ 
              color: '#666666',
              lineHeight: '1.7',
              marginBottom: '24px'
            }}>
              At EASY2HOME, our mission is to make quality bathroom accessories accessible to everyone. We strive to combine functionality, durability, and elegant design in every product we offer.
            </p>
            <p className="body-large" style={{ 
              color: '#666666',
              lineHeight: '1.7'
            }}>
              We are committed to innovation, sustainability, and customer satisfaction. Our team continuously researches and develops new products that meet the evolving needs of modern homes.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section-padding-small" style={{
        backgroundColor: '#333333',
        color: '#fffef2'
      }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '48px',
            textAlign: 'center'
          }}>
            <div>
              <div className="hero-large" style={{ 
                color: '#fffef2',
                marginBottom: '8px'
              }}>
                10,000+
              </div>
              <p className="body-regular" style={{ color: '#bcbbb4' }}>
                Happy Customers
              </p>
            </div>
            <div>
              <div className="hero-large" style={{ 
                color: '#fffef2',
                marginBottom: '8px'
              }}>
                4.2★
              </div>
              <p className="body-regular" style={{ color: '#bcbbb4' }}>
                Average Rating
              </p>
            </div>
            <div>
              <div className="hero-large" style={{ 
                color: '#fffef2',
                marginBottom: '8px'
              }}>
                50+
              </div>
              <p className="body-regular" style={{ color: '#bcbbb4' }}>
                Products
              </p>
            </div>
            <div>
              <div className="hero-large" style={{ 
                color: '#fffef2',
                marginBottom: '8px'
              }}>
                100%
              </div>
              <p className="body-regular" style={{ color: '#bcbbb4' }}>
                Quality Assured
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
